'use client';
/** @jsxRuntime classic */
/** @jsx jsx */

import { jsx } from '@emotion/react';
import { FC } from 'react';
import get from 'lodash/get';
import cn from '../Utils/cn';

interface ProgressBarProps {
	progress: number | null;
	barColor?: string;
	compact?: boolean;
}

const ProgressBar: FC<ProgressBarProps> = ({ progress, barColor = '', compact = false }) => (
	<div
		className={cn('bg-[#d6d6d6] rounded-full h-[1.1rem] w-full relative', compact ? 'mt-2 mb-2' : 'mt-8 mb-4')}
	>
		<div className={cn("progress bg-brand-main rounded-full h-4 top-0 left-0", `bg-${(barColor ? barColor : 'brand-main').replace?.(/\./, '-')}`)} style={{width: progress + '%', backgroundColor: barColor}} />
	</div>
);

export default ProgressBar;
